import { createGlobalKey } from "@aviv-unified-frontend/internal";

export const GLOBAL_KEY = createGlobalKey("global");

export const GLOBAL_STORE_KEY = createGlobalKey("store");
